import { Tooltip } from '@/components/tooltip';
import { WaveLoader } from '@/components/wave-loader';

import { useExplorationUIContext } from '../../exploration-ui-context';

import styles from './loader.module.scss';

interface ConversationProgressProps {
  conversationId: string;
}

export const ConversationProgress = ({ conversationId }: ConversationProgressProps) => {
  const { conversations, conversationAbortCallbacks } = useExplorationUIContext();
  const message = conversations[conversationId]?.progress.general;

  const handleAbort = () => {
    conversationAbortCallbacks.current.get(conversationId)?.();
  };

  return (
    <div className={styles.conversationProgress}>
      <div className={styles.wrapper}>
        <div className={styles.message}>
          <WaveLoader />
          {message ?? 'Still thinking...'}
          <Tooltip content="Cancel the request">
            <button type="button" className={styles.abortBtn} onClick={handleAbort} />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

interface ConversationProgressNewProps {
  statusMessage: string;
  onAbort: () => void;
}

export const ConversationProgressNew = (props: ConversationProgressNewProps) => {
  const { statusMessage, onAbort } = props;

  return (
    <div className={styles.conversationProgress2}>
      <div className={styles.wrapper}>
        <div className={styles.message}>
          <WaveLoader />
          {statusMessage ?? 'Still thinking...'}
          <Tooltip content="Cancel the request">
            <button type="button" className={styles.abortBtn} onClick={onAbort} />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
